import {
  apiGetPresentations,
  apiCreatePresentation,
  apiCopyPresentation,
  apiSetPresentationToPublic,
  apiSetPresentationToPrivate,
  apiDeletePresentation
} from '../../common/api/lesson'

const fetchMyPresentations = params => ({
  requestPrefix: 'MY_PRESENTATIONS:FETCH',
  params,
  request: () =>
    apiGetPresentations({
      scope: params.scope || 'all',
      search_string: params.search_string || null,
      order_by: params.order_by || null,
      include: `presentation.policy,presentation.image,presentation.names,presentation.asset_data,presentation.timestamps,presentation.details,presentation.lesson.delivery_stats,presentation.lesson.status,presentation.lesson.delivery_stats,presentations.limit.${
        params.limit
      },presentations.page.${params.page},presentations.order.${params.order ||
        'desc'}`
    })
})

const createPresentation = data => ({
  requestPrefix: 'MY_PRESENTATIONS:CREATE',
  request: () => apiCreatePresentation(data)
})

const copyPresentation = id => ({
  requestPrefix: 'MY_RESENTATIONS:COPY',
  params: { id },
  request: () =>
    apiCopyPresentation(id, {
      include:
        'presentation.names,presentation.details,presentation.lesson.delivery_stats,presentation.lesson.status'
    })
})

const setPresentationToPublic = (id, params) => ({
  requestPrefix: 'MY_PRESENTATIONS:SET_TO_PUBLIC',
  params: { id },
  request: () => apiSetPresentationToPublic(id, params)
})

const setPresentationToPrivate = id => ({
  requestPrefix: 'MY_PRESENTATIONS:SET_TO_PRIVATE',
  params: { id },
  request: () => apiSetPresentationToPrivate(id)
})

const deletePresentation = id => ({
  requestPrefix: 'MY_PRESENTATIONS:DELETE',
  params: { id },
  request: () => apiDeletePresentation(id)
})

export {
  fetchMyPresentations,
  createPresentation,
  copyPresentation,
  setPresentationToPublic,
  setPresentationToPrivate,
  deletePresentation
}
